import LondonImg from './Images/holiday-london.jpg';
import DubaiImg from './Images/holiday-dubai.jpg';
import ParisImg from './Images/holiday-paris.jpg';

let LastHolidaysItems = [
    {
        id: 1,
        itemImage: LondonImg,
        itemTitle: 'London',
        itemDescription: 'Explore historic landmarks, hidden cafés, vibrant street markets and world-class museums in one of Europe’s most iconic cities.'
    },
    {
        id: 2,
        itemImage: DubaiImg,
        itemTitle: 'Dubai',
        itemDescription: 'From desert safaris to rooftop dining and luxury shopping, Dubai offers a perfect mix of adventure, culture and modern lifestyle.'
    },
    {
        id: 3,
        itemImage: ParisImg,
        itemTitle: 'Paris',
        itemDescription: 'Stroll along the Seine, discover charming neighbourhoods and enjoy authentic cuisine in the city that defines romance and art.'
    }
];

export default LastHolidaysItems;
